import ReactDOM from "react-dom";

export default function ProfilePortal({ children }) {
  const portalRoot = document.getElementById("portal-profile");

  if (!portalRoot) return null;

  return ReactDOM.createPortal(children, portalRoot);
}
